@use "../../styles/breakpoint.module.scss" as *;

.root {
    composes: repeater from "../../styles/layout.module.scss";
    position: relative;
    height: 640px;
    overflow: hidden;
    grid-template-rows: 1fr;

    @media ($below-tablet) {
        height: 560px;
    }

    @media ($below-mobile) {
        height: 480px;
    }
}

.image {
    position: absolute;
    inset: 0;

    img {
        width: 100%;
        height: 100%;
        object-fit: cover;
        display: block;
    }
}

.content {
    grid-column: 1 / -1;
    display: grid;
    grid-template-columns: subgrid;
    margin-top: auto;
    padding-bottom: var(--spacer-48);
    position: relative;
    z-index: 1;
    padding-top: var(--spacer-120);

    &::before {
        content: "";
        position: absolute;
        inset: 0;
        background: linear-gradient(
            0deg,
            rgb(0 0 0 / 90%) 0%,
            rgb(0 0 0 / 0%) 100%
        );
        z-index: -1;
        pointer-events: none;
    }
}

.eyebrow {
    composes: fontST24 from "../../styles/typography.module.scss";
    grid-column: col-start 3 / col-end 10;
    text-align: center;
    margin: 0;
    color: var(--white);
    font-weight: 800;

    @media ($below-mobile) {
        grid-column: content;
    }
}

.headline {
    composes: fontHB104 from "../../styles/typography.module.scss";
    grid-column: content;
    text-align: center;
    margin: 0;
    margin-top: var(--spacer-16);
    color: var(--white);
}

.body {
    composes: fontP20 from "../../styles/typography.module.scss";
    grid-column: col-start 4 / col-end 9;
    text-align: center;
    margin: 0;
    margin-top: var(--spacer-24);
    color: var(--white);

    @media ($below-mobile) {
        grid-column: content;
        font-size: 16px;
    }
}

.cta {
    grid-column: col-start 3 / col-end 10;
    display: flex;
    justify-content: center;
    margin-top: var(--spacer-24);

    @media ($below-mobile) {
        grid-column: content;
    }
}
